/* Vue dependecies */
import Vue from 'vue'
import Router from 'vue-router'
import VueGtm from 'vue-gtm'

/* Centralized States */
import store from './../store'

/* Layouts */
import Public from '@/layouts/Public'
import Protected from '@/layouts/Protected'
import LayoutLoans from '@/layouts/LayoutLoans'

/* Pages */
import Login from '@/pages/Login'
// import VerifyPassword from '@/pages/VerifyPassword'
import SignUp from '@/pages/SignUp'
import Home from '@/pages/Home'
import MyInsurance from '@/pages/MyInsurance'
import Profile from '@/pages/Profile'
// import Welcome from '@/pages/Welcome'
import MoreInsurances from '@/pages/MoreInsurances'
import ElectronicVouchers from '@/pages/ElectronicVouchers'
import Formalities from '@/pages/Formalities'
import FormalitiesSOATCancellation from '@/pages/soat/FormalitiesSOATCancellation'
// import ResetPassword from '@/pages/ResetPassword'
import Loans from '@/pages/Loans/Loans'
import Operations from '@/pages/Loans/Operations'
import LoansFinished from '@/pages/Loans/LoansFinished'
import PaymentMehodChange from '@/pages/PaymentMehodChange'
import PaymentQuotes from '@/pages/PaymentQuotes'
import PrestamoVida from '@/pages/PrestamoVida'
import PrestamoVidaSolicitud from '@/pages/PrestamoVidaSolicitud'
import Prepaids from '@/pages/Prepaids/Index'
import PrepaidProcess from '@/pages/Prepaids/Process'

import ProfileBenefits from '@/pages/ProfileBenefits'

import LandingPrincipal from '@/pages/LandingPrincipal'
import LandingAsistencia from '@/pages/LandingAsistencia'
import LandingBenefits from '@/pages/LandingBenefits'
import MisSeguros from '@/pages/mis-seguros/MisSeguros'
import VidaFree from '@/pages/vida-free/VidaFree'

/** Alerts as a Pages */
import NotRememberPassword from '@/pages/messages/NotRememberPassword'

/* Message of Process */
// import RegisterSuccessful from '@/pages/confirmation/RegisterSuccessful'
// import ResetPasswordSuccessful from '@/pages/confirmation/ResetPasswordSuccessful'

// import Maintenance from '@/pages/Maintenance'

import HelpCenter from '@/pages/HelpCenter'

Vue.use(Router)

const router = new Router({
  base: process.env.ROUTER_BASE,
  routes: [
    {
      path: '/iniciar-sesion',
      component: Login,
      name: 'MakeLogin',
      beforeEnter (to, from, next) {
        if (localStorage.getItem('outoftime') === null && store.state.user.user != null) {
          next('/inicio')
        } else if (localStorage.getItem('outoftime') && store.state.user.user != null) {
          localStorage.removeItem('outoftime')
          localStorage.removeItem('jwt')
          store.state.user.session = null
          store.state.user.jwt = null
          store.state.user.coUs = null
          store.state.user.info = null
          store.state.user.user = null
          store.state.user.polizas = null
          store.state.user.historyPayments = null
          store.state.user.exp = null
          store.state.user.names = null
          next()
        } else {
          next()
        }
      }
    },
    {
      path: '/',
      component: Public,
      redirect: '/iniciar-sesion',
      children: [
        {
          path: '/',
          props: true,
          component: Login,
          name: 'MakeLogin',
          beforeEnter (to, from, next) {
            if (store.state.user.user != null) {
              next('/inicio')
            } else {
              next()
            }
          }
        },
        {
          path: 'registrate',
          props: true,
          component: SignUp,
          name: 'SignUp',
          beforeEnter (to, from, next) {
            if (store.state.user.user != null) {
              next('/inicio')
            } else {
              next()
            }
          }
        },
        {
          path: 'recuperar-contraseña',
          name: 'RecoveryPassword',
          // La recuperación ahora es con OTP de CR Auth en SignUp (que ya envía a /inicio si hay sesión)
          redirect: to => ({ name: 'SignUp', params: { source: 'recovery', numeroDocumento: to.params.numeroDocumento, tipoDocumento: to.params.tipoDocumento } })
        }
        /*
        {
          path: 'verificar-clave',
          component: VerifyPassword,
          props: true,
          name: 'VerifyPassword',
          beforeEnter (to, from, next) {
            if (store.state.user.user != null) {
              next('/iniciar-sesion')
            } else {
              next()
            }
          }
        },
        {
          path: 'bienvenido',
          component: Welcome,
          props: true,
          name: 'Welcome',
          beforeEnter (to, from, next) {
            if (store.state.user.user != null) {
              next('/inicio')
            } else {
              next()
            }
          }
        },
        {
          path: 'registro-exitoso',
          component: RegisterSuccessful,
          name: 'RegisterSuccessful',
          beforeEnter (to, from, next) {
            if (store.state.user.user != null) {
              next('/inicio')
            } else {
              next()
            }
          }
        },
        {
          path: 'restablecer-contraseña',
          props: true,
          component: ResetPassword,
          name: 'ResetPassword',
          beforeEnter (to, from, next) {
            if (store.state.user.user != null) {
              next('/inicio')
            } else {
              next()
            }
          }
        },
        {
          path: 'actualizacion-exitosa',
          component: ResetPasswordSuccessful,
          name: 'ResetPasswordSuccessful',
          beforeEnter (to, from, next) {
            if (store.state.user.user != null) {
              next('/inicio')
            } else {
              next()
            }
          }
        },
        {
          path: 'no-recuerdo-datos',
          props: true,
          component: NotRememberPassword,
          name: 'NotRememberPassword'
        }
        */
      ]
    },

    {
      path: '/',
      component: Protected,
      redirect: '/inicio',
      children: [
        {
          path: 'inicio',
          component: Home,
          name: 'Home',
          beforeEnter (to, from, next) {
            if (store.state.user.user != null) {
              next()
            } else {
              next('/iniciar-sesion')
            }
          }
        },
        {
          path: 'mis-seguros',
          component: MyInsurance,
          name: 'MyInsurances',
          beforeEnter (to, from, next) {
            if (store.state.user.user != null) {
              next()
            } else {
              next('/iniciar-sesion')
            }
          }
        },
        {
          path: 'mi-perfil',
          component: Profile,
          name: 'Profile',
          beforeEnter (to, from, next) {
            if (store.state.user.user != null) {
              next()
            } else {
              next('/iniciar-sesion')
            }
          }
        },
        {
          path: 'comprobantes-electronicos',
          component: ElectronicVouchers,
          name: 'ElectronicVouchers',
          beforeEnter (to, from, next) {
            if (store.state.user.user != null) {
              next()
            } else {
              next('/iniciar-sesion')
            }
          }
        },
        {
          path: 'mas-seguros',
          component: MoreInsurances,
          name: 'MoreInsurances',
          beforeEnter (to, from, next) {
            if (store.state.user.user != null) {
              next()
            } else {
              next('/iniciar-sesion')
            }
          }
        },
        {
          path: 'solicitudes',
          component: Formalities,
          props: true,
          name: 'Formalities',
          beforeEnter (to, from, next) {
            if (store.state.user.user != null) {
              next()
            } else {
              next('/iniciar-sesion')
            }
          }
        },
        {
          path: 'solicitudes-soat',
          component: FormalitiesSOATCancellation,
          props: true,
          name: 'FormalitiesSOATCancellation',
          beforeEnter (to, from, next) {
            if (store.state.user.user != null) {
              next()
            } else {
              next('/iniciar-sesion')
            }
          }
        },
        {
          path: 'cambio-via-cobro',
          component: PaymentMehodChange,
          name: 'PaymentMehodChange',
          props: true,
          beforeEnter (to, from, next) {
            if (store.state.user.user != null) {
              next()
            } else {
              next('/iniciar-sesion?dl=cambio-via-cobro')
            }
          }
        },
        {
          path: 'pago-de-cuotas',
          component: PaymentQuotes,
          name: 'PaymentQuotes',
          beforeEnter (to, from, next) {
            if (store.state.user.user != null) {
              next()
            } else {
              next('/iniciar-sesion?dl=pago-de-cuotas')
            }
          }
        },
        {
          path: 'prestamos-vida',
          component: PrestamoVida,
          name: 'PrestamoVida',
          beforeEnter (to, from, next) {
            if (store.state.user.user != null) {
              next()
            } else {
              next('/iniciar-sesion?dl=prestamos-vida')
            }
          }
        },
        {
          path: 'prestamos-vida/solicitud',
          component: PrestamoVidaSolicitud,
          name: 'PrestamoVidaSolicitud',
          beforeEnter (to, from, next) {
            if (store.state.user.user != null) {
              next()
            } else {
              next('/iniciar-sesion?dl=prestamos-vida-solicitud')
            }
          }
        },
        {
          path: '/vivemas',
          component: LandingPrincipal,
          name: 'Vivemas',
          beforeEnter (to, from, next) {
            if (store.state.user.user != null) {
              next('/vivemas-beneficios')
            } else {
              next({
                path: '/iniciar-sesion?dl=' + encodeURIComponent(to.fullPath.substring(1)),
              })
            }
          }
        },
        {
          path: '/vivemas-beneficios',
          name: 'BenefitsVivemas',
          component: LandingBenefits,
          beforeEnter (to, from, next) {
            if (store.state.user.user != null) {
              next()
            } else {
              next({
                path: '/iniciar-sesion?dl=' + encodeURIComponent(to.fullPath.substring(1)),
              })
            }
          }
        },
        {
          path: '/vivemas-descuentos',
          component: LandingBenefits,
          name: 'DescuentosVivemas',
          props: true,
          beforeEnter (to, from, next) {
            if (store.state.user.user != null) {
              next({
                path: '/vivemas-beneficios',
                query: {
                  ...to.query
                },
              });
            } else {
              next({
                path: '/iniciar-sesion?dl=' + encodeURIComponent(to.fullPath.substring(1)),
              })
            }
          }
        },
        {
          path: '/vivemas-asistencias',
          component: LandingAsistencia,
          name: 'AsistenciasVivemas',
          props: true,
          beforeEnter (to, from, next) {
            if (store.state.user.user != null) {
              next({
                path: '/vivemas-beneficios',
                query: {
                  ...to.query
                },
              });
            } else {
              next({
                path: '/iniciar-sesion?dl=' + encodeURIComponent(to.fullPath.substring(1)),
              })
            }
          }
        },
        {
          path: '/beneficiarios',
          component: ProfileBenefits,
          name: 'PerfilBeneficiarios',
          props: true,
          beforeEnter (to, from, next) {
            if (store.state.user.user != null) {
              next()
            } else {
              next('/iniciar-sesion')
            }
          }
        },
        {
          path: 'help-center',
          component: HelpCenter,
          name: 'HelpCenter',
          beforeEnter (to, from, next) {
            if (store.state.user.user != null) {
              next()
            } else {
              next('/iniciar-sesion')
            }
          }
        },
        {
          path: '/plan-garantizado',
          component: MisSeguros,
          name: 'PlanGarantizado',
          props: true,
          beforeEnter (to, from, next) {
            if (store.state.user.user != null) {
              next()
            } else {
              next('/iniciar-sesion')
            }
          }
        },
        {
          path: '/vida-free',
          component: VidaFree,
          name: 'VidaFree',
          props: true,
          beforeEnter (to, from, next) {
            if (store.state.user.user != null) {
              next()
            } else {
              next('/iniciar-sesion')
            }
          }
        },
        {
          path: '/vida-cash',
          component: MisSeguros,
          name: 'VidaCash',
          props: true,
          beforeEnter (to, from, next) {
            if (store.state.user.user != null) {
              next()
            } else {
              next('/iniciar-sesion')
            }
          }
        },
        {
          path: '/rumbo',
          component: MisSeguros,
          name: 'Rumbo',
          props: true,
          beforeEnter (to, from, next) {
            if (store.state.user.user != null) {
              next()
            } else {
              next('/iniciar-sesion')
            }
          }
        }
      ]
    },
    // PRESTAMOS
    {
      path: '/prestamos',
      redirect: '/prestamos/operaciones',
      component: LayoutLoans,
      children: [
        {
          path: 'operaciones',
          component: Operations
        },
        {
          path: 'paso/cotizar',
          component: Loans
        },
        {
          path: 'no-recuerdo-datos',
          props: true,
          component: NotRememberPassword,
          name: 'NotRememberPassword'
        },
        {
          path: 'registro-exitoso',
          props: true,
          component: LoansFinished,
          name: 'LoansFinished'
        },
        {
          path: 'no-recibi-codigo',
          name: 'noReceivedCode',
          // El reenvío del código ahora es con OTP de CR Auth en SignUp
          redirect: to => ({ name: 'SignUp', params: { source: 'recovery', numeroDocumento: to.params.numeroDocumento, tipoDocumento: to.params.tipoDocumento } })
        }
      ]
    },
    // PREPAGO
    {
      path: '/prepago',
      redirect: '/prepago/cotizar',
      component: LayoutLoans,
      children: [
        {
          path: 'cotizar',
          component: Prepaids,
          name: 'Prepaids'
        },
        {
          path: '/proceso-prestamo',
          props: true,
          component: PrepaidProcess,
          name: 'PrepaidProcess'
        }
      ]
    }
  ],
  mode: 'history'
})

/*
{
  path: '/',
  component: Public,
  children: [
    {
      path: '/',
      component: Maintenance,
      name: 'Maintenance'
    }
  ]
},
*/

Vue.use(VueGtm, {
  id: process.env.GTM_CODE, // Your GTM ID
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  // debug: true, // Whether or not display console logs debugs (optional)
  vueRouter: router // Pass the router instance to automatically sync with router (optional)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js